export interface MessageRow {
  id: string;
  thread_id: string;
  created_at: string;
  sender_type?: "sales" | "client" | string | null;
  sender_name?: string | null;
  content?: string | null;
  metadata?: MessageMetadata | null;
  [key: string]: unknown;
}

export interface AttachedFileMetadata {
  id?: string;
  type?: string;
  name?: string;
  file_url?: string;
  label?: string;
}

export interface InboundAttachmentMetadata {
  filename: string;
  contentType?: string;
  size?: number;
  url: string;
  storagePath?: string;
}

export interface MessageMetadata {
  attachedFiles?: AttachedFileMetadata[];
  attachments?: InboundAttachmentMetadata[];
  [key: string]: unknown;
}

export function mergeMessages(
  existing: MessageRow[],
  incoming: MessageRow[]
): MessageRow[] {
  const map = new Map<string, MessageRow>();
  existing.forEach((item) => map.set(item.id, item));
  incoming.forEach((item) => map.set(item.id, item));

  return Array.from(map.values()).sort(
    (a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );
}
